import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getSleeve } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class SleeveContainer extends React.Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.request(id);
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || [];
    const { sleeve, next, previous } = result;
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && sleeve.length === 0) {
      return null;
    }
    return render({ sleeve, next, previous, loading, failure });
  };
}

export default CreateContainer(getSleeve, SleeveContainer);
